import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as CustomChartSVG } from 'assets/svgs/chart-vector.svg';
import { ReactComponent as CustomCardSVG } from 'assets/svgs/hashtag.svg';
import { IconWrapper } from './styles';

const StyledCustomCardSvg = styled(CustomCardSVG)`
  width: 75px;
`;

const StyledCustomChartSvg = styled(CustomChartSVG)`
  width: var(--spacing-10);
`;

export const CustomCardIcon: FC = () => {
  return (
    <IconWrapper>
      <StyledCustomCardSvg />
      <FormattedMessage id="dashboard.widget_type.custom_card.title" />
    </IconWrapper>
  );
};

export const CustomChartIcon: FC = () => {
  return (
    <IconWrapper>
      <StyledCustomChartSvg />
      <FormattedMessage id="dashboard.widget_type.custom_chart.title" />
    </IconWrapper>
  );
};
